/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const sendChatMessage = /* GraphQL */ `
  mutation SendChatMessage(
    $messageInBase64: String!
    $recipientSub: String!
    $price: Float
    $isPurchased: Boolean
  ) {
    sendChatMessage(
      messageInBase64: $messageInBase64
      recipientSub: $recipientSub
      price: $price
      isPurchased: $isPurchased
    ) {
      senderSub
      recipientSub
      inboxOwner
      sentAt
      status
      messageInBase64
      price
      isPurchased
      __typename
    }
  }
`;
export const deleteConversation = /* GraphQL */ `
  mutation DeleteConversation($recipientSub: String!) {
    deleteConversation(recipientSub: $recipientSub)
  }
`;
export const createSocialPost = /* GraphQL */ `
  mutation CreateSocialPost(
    $text: String
    $assetPath: String!
    $isAdult: Boolean!
    $price: PostPrice
  ) {
    createSocialPost(
      text: $text
      assetPath: $assetPath
      isAdult: $isAdult
      price: $price
    ) {
      _id
      author {
        publicName
        _id
        __typename
      }
      dateCreated
      text
      price
      isAdult
      currency
      assetPath
      license
      likeCount
      deleted
      __typename
    }
  }
`;
export const deleteSocialPost = /* GraphQL */ `
  mutation DeleteSocialPost($postId: ID!) {
    deleteSocialPost(postId: $postId) {
      _id
      author {
        publicName
        _id
        __typename
      }
      dateCreated
      text
      price
      isAdult
      currency
      assetPath
      license
      likeCount
      deleted
      __typename
    }
  }
`;
export const replyToSocialPost = /* GraphQL */ `
  mutation ReplyToSocialPost($postId: ID!, $reply: String!) {
    replyToSocialPost(postId: $postId, reply: $reply) {
      _id
      author {
        publicName
        _id
        __typename
      }
      dateCreated
      text
      price
      isAdult
      currency
      assetPath
      license
      likeCount
      deleted
      __typename
    }
  }
`;
export const deleteReplyFromSocialPost = /* GraphQL */ `
  mutation DeleteReplyFromSocialPost($postId: ID!, $reply: String!) {
    deleteReplyFromSocialPost(postId: $postId, reply: $reply) {
      _id
      author {
        publicName
        _id
        __typename
      }
      dateCreated
      text
      price
      isAdult
      currency
      assetPath
      license
      likeCount
      deleted
      __typename
    }
  }
`;
export const likeSocialPost = /* GraphQL */ `
  mutation LikeSocialPost($postId: ID!) {
    likeSocialPost(postId: $postId) {
      _id
      author {
        publicName
        _id
        __typename
      }
      dateCreated
      text
      price
      isAdult
      currency
      assetPath
      license
      likeCount
      deleted
      __typename
    }
  }
`;
export const unlikeSocialPost = /* GraphQL */ `
  mutation UnlikeSocialPost($likeId: ID!) {
    unlikeSocialPost(likeId: $likeId) {
      _id
      author {
        publicName
        _id
        __typename
      }
      dateCreated
      text
      price
      isAdult
      currency
      assetPath
      license
      likeCount
      deleted
      __typename
    }
  }
`;
export const purchaseSocialPost = /* GraphQL */ `
  mutation PurchaseSocialPost($postId: ID!) {
    purchaseSocialPost(postId: $postId)
  }
`;
